import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CargoItemsService } from './logic/cargo-item.service';
import { CargoItemsLogicService } from './logic/cargo-item/cargo-item-logic.service';
import { CargoItemsDaoService } from './dao/cargo-item-dao.service';
import { CargoItemsDbDaoService } from './dao/cargo-item-dao/cargo-item-db-dao.service';
import { CargoItemDbTableDefinition } from './dao/cargo-item-dao/cargo-item-db-table-definition';
import { LocalCargoItemDbTableDefinition } from './dao/cargo-item-dao/local-cargo-item-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: CargoItemsService, useClass: CargoItemsLogicService },
    { provide: CargoItemsDaoService, useClass: CargoItemsDbDaoService },
    { provide: CargoItemDbTableDefinition },
    { provide: LocalCargoItemDbTableDefinition },
  ]
})
export class CargoItemsModule {}
